import { http } from '@/utils'
const inflight: Partial<Record<string, Promise<number>>> = {}

type FxReq = { amount?: number; from_currency: string; to_currency: string }
type FxResp = { rate: number; amount: number; currency: string } // 约定后端返回结构，可按实际调整

export async function fetchRateOnce(
  { from_currency, to_currency }: FxReq,
  retry = 2,
): Promise<number> {
  const key = `${from_currency}->${to_currency}`
  if (inflight[key]) return inflight[key]

  inflight[key] = (async () => {
    let err: unknown
    for (let i = 0; i <= retry; i++) {
      try {
        const data: FxResp = await http.post(`/api/comm/currency_exchange`, {
          amount: 1,
          from_currency,
          to_currency,
        })
        return data.rate
      } catch (e) {
        err = e
        if (i < retry) await new Promise((r) => setTimeout(r, 300 * (i + 1)))
      }
    }
    throw err
  })()

  try {
    return await inflight[key]
  } finally {
    delete inflight[key]
  }
}
